import config from 'config/config';
import { RampWidgetConfig } from '../interfaces';

export const DEFAULT_WIDGET_CONFIG: Pick<
  RampWidgetConfig,
  'hostAppName' | 'hostLogoUrl' | 'hostApiKey' | 'url' | 'swapAsset'
> = {
  hostAppName: 'OkLetsPlay',
  hostLogoUrl: 'https://okletsplay.com/favicon.ico',
  hostApiKey: config.rampHostApiKey,
  url: config.rampWidgetUrl,
  swapAsset: config.rampDefaultTokenName,
};
